import { useTranslation } from 'react-i18next'
import { getCanRentalContractMachine } from '~/entities/common/RentalContract'
import { RentalContractStatusEnum } from '~/shared/config/enums'
import {
  RentalContractCanceled,
  RentalContractContinue,
  RentalContractActive,
  RentalContractSuspend,
  RentalContractTerminate,
} from '~/widgets/common/Driver/RentalContractControls'

type ActionsProps = {
  rentalContractId: UniqueId
  status: RentalContractStatusEnum
}

export function Actions({ status, rentalContractId }: ActionsProps) {
  const { t } = useTranslation()

  const canStatus = getCanRentalContractMachine(status)
  return (
    <>
      {canStatus?.signing && (
        <RentalContractActive
          isIcon
          rentalContractId={rentalContractId}
          title={t('sign the contract')}
          modalTitle={`${t('sign the contract')} ?`}
          modalButtonTitle={t('button.sign')}
        />
      )}
      {canStatus?.active && (
        <RentalContractActive isIcon rentalContractId={rentalContractId} />
      )}
      {canStatus?.canceled && (
        <RentalContractCanceled isIcon rentalContractId={rentalContractId} />
      )}
      {canStatus?.terminate && (
        <RentalContractTerminate isIcon rentalContractId={rentalContractId} />
      )}
      {canStatus?.suspend && (
        <RentalContractSuspend isIcon rentalContractId={rentalContractId} />
      )}
      {canStatus?.continue && (
        <RentalContractContinue isIcon rentalContractId={rentalContractId} />
      )}
    </>
  )
}
